import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StatusProvider } from "@/context/StatusContext";
import { initTheme } from "@/lib/theme";
import Layout from "@/components/Layout";
import MobileLayout from "@/components/MobileLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tickets from "@/pages/Tickets";
import Manutenzione from "@/pages/Manutenzione";
import TicketDetail from "@/pages/TicketDetail";
import Pianificazione from "@/pages/Pianificazione";
import Risultati from "@/pages/Risultati";
import Presenze from "@/pages/Presenze";
import Anagrafiche from "@/pages/Anagrafiche";
import Utenti from "@/pages/Utenti";
import Impostazioni from "@/pages/Impostazioni";
import Profilo from "@/pages/Profilo";
import Carburante from "@/pages/Carburante";
import Trasferimenti from "@/pages/Trasferimenti";
import MobileTicketDetail from "@/pages/mobile/MobileTicketDetail";
import MobileAgenda from "@/pages/mobile/MobileAgenda";
import MobileMateriali from "@/pages/mobile/MobileMateriali";
import MobileProfilo from "@/pages/mobile/MobileProfilo";
import MobileCarburante from "@/pages/mobile/MobileCarburante";

initTheme();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "tecnico") return <Navigate to="/m/agenda" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function MobileProtected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "tecnico") return <Navigate to="/dashboard" replace />;
  return <MobileLayout>{children}</MobileLayout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <StatusProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/tickets" element={<Protected><Tickets /></Protected>} />
            <Route path="/tickets/:id" element={<Protected><TicketDetail /></Protected>} />
            <Route path="/manutenzione" element={<Protected roles={["admin", "responsabile"]}><Manutenzione /></Protected>} />
            <Route path="/pianificazione" element={<Protected><Pianificazione /></Protected>} />
            <Route path="/risultati" element={<Protected roles={["admin", "responsabile"]}><Risultati /></Protected>} />
            <Route path="/presenze" element={<Protected roles={["admin", "responsabile"]}><Presenze /></Protected>} />
            <Route path="/anagrafiche" element={<Protected roles={["admin", "responsabile"]}><Anagrafiche /></Protected>} />
            <Route path="/utenti" element={<Protected roles={["admin", "responsabile"]}><Utenti /></Protected>} />
            <Route path="/carburante" element={<Protected roles={["admin", "responsabile"]}><Carburante /></Protected>} />
            <Route path="/trasferimenti" element={<Protected roles={["admin", "responsabile"]}><Trasferimenti /></Protected>} />
            <Route path="/impostazioni" element={<Protected roles={["admin"]}><Impostazioni /></Protected>} />
            <Route path="/profilo" element={<Protected><Profilo /></Protected>} />
            <Route path="/m/agenda" element={<MobileProtected><MobileAgenda /></MobileProtected>} />
            <Route path="/m/materiali" element={<MobileProtected><MobileMateriali /></MobileProtected>} />
            <Route path="/m/carburante" element={<MobileProtected><MobileCarburante /></MobileProtected>} />
            <Route path="/m/profilo" element={<MobileProtected><MobileProfilo /></MobileProtected>} />
            <Route path="/m/tickets/:id" element={<MobileProtected><MobileTicketDetail /></MobileProtected>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
        </StatusProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
